import * as t from 'io-ts';
import { ModelDerivedData, ModelFiles, ModelIdData, ModelTenant } from '../base';
import * as Timestamp from './timestamp';
import * as MPK from './modelPartitionKey';
/** A complete model item as stored in DynamoDB Models table */
export const Data = t.intersection([
    t.exact(MPK.ModelPartitionKey),
    t.exact(ModelIdData),
    t.exact(ModelDerivedData),
    t.exact(ModelFiles),
    t.exact(ModelTenant),
]);
const emptyFile = { location: null, created: null, lastModified: null };
export function fromModelInput(m, tenant) {
    const timestamp = Timestamp.create();
    return {
        ...m,
        // start with a 'complete' but empty map of files to make partial updating easier later
        files: {
            attachments: {
                json: emptyFile,
                blend: emptyFile,
            },
            model: { max: emptyFile, glb: emptyFile, blend: emptyFile },
        },
        kind: m.articleType === 'ar-model' ? 'ar' : 'article',
        notes: '',
        status: 'not-ready',
        created: timestamp,
        lastModified: timestamp,
        tenant,
        partitionKey: MPK.fromAttributes(tenant, m.productId),
    };
}
